<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showHistorial"
    no-close-on-backdrop
    scrollable
    title="historial"
    cancel-variant="outline-secondary"
    ok-only
    @hidden="reset"
  >
    <v-select
      placeholder="Seleccione el periodo"
      :options="listPeriodos"
      :clearable="false"
      style="width: 100%; text-transform:capitalize"
      @input="changePeriodo"
      v-model="periodoSeleccionado"
      class="mb-2"
    />
    <div v-if="periodoSeleccionado == null" style="height:200px"></div>
    <b-overlay :show="showLoading" rounded="sm">
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="item in listJugadores"
          :key="item.id"
        >
          <b-row>
            <b-col md="2" style="padding-left:5px">
              <b-form-input
                v-model="item.num_camiseta"
                placeholder="#"
                class="d-flex"
              />
              <span style="font-size:9px">{{ item.tipo_jugador_usar }}</span>
              <span style="font-size:8px" class="d-block">{{
                item.tipo_adicional
              }}</span>
            </b-col>
            <b-col md="5" class="p-0">
              <b-media vertical-align="center">
                <template #aside>
                  <div style="display:grid">
                    <b-avatar
                      size="42"
                      :src="item.foto_jug"
                      :text="avatarText(item.nombres)"
                    />
                  </div>
                </template>
                <span class="font-weight-bold d-block text-nowrap">
                  {{ item.apellidos }} {{ item.nombres }}
                </span>
                <small class="text-muted">{{ item.ci_pasaporte }}</small>
              </b-media>
            </b-col>
            <b-col md="2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                size="sm"
                class="mt-2"
                style="float:left"
                @click="addPlayer(item)"
              >
                Agregar
              </b-button>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-overlay>
    <template #modal-footer>
      <div class="w-100">
        <template>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>

        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>
<script>
import vSelect from 'vue-select'
import {
  BModal,
  BListGroup,
  BListGroupItem,
  BMedia,
  BAvatar,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BAlert,
  BOverlay,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { heightFade } from '@core/directives/animations'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
  //   ESTADO_JUGADOR,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    vSelect,
    BListGroup,
    BListGroupItem,
    BMedia,
    BAvatar,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BAlert,
    BOverlay,
  },
  props: {
    listPeriodos: Array,
    equipoSeleccionado: Object,
  },
  directives: {
    Ripple,
    heightFade,
  },
  setup(props, { emit }) {
    const periodoSeleccionado = ref(null)
    const listJugadores = ref([])
    const messageError = ref('')
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const hasError = ref(false)
    const showLoading = ref(false)

    const { getApi, postApi } = apiCall()
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    async function changePeriodo() {
      showLoading.value = true
      const path = `ApiInscripciones/getJugaoresHistorialCampeonato/${periodoSeleccionado.value.value}/${props.equipoSeleccionado.value}`
      const data = await getApi(URL, path)
      listJugadores.value = data.data
      showLoading.value = false
    }
    async function addPlayer(item) {
      // console.log(periodoSeleccionado.value)
      const path = 'ApiInscripciones/addHistorial'
      const dataSend = {
        rol: USER().rol,
        id_jugador: item.id_jugador,
        id_equipo: props.equipoSeleccionado.value,
        num_camiseta: item.num_camiseta,
        tipoJugador: item.tipo_jugador_usar,
        tipoJugadorAdicional: item.tipo_adicional,
        id_disciplina: item.id_disciplina,
        fecha_nac: item.fecha_nac,
        id_campeonato: props.equipoSeleccionado.campeonato.id_campeonato,
      }
      //   rol, id_jugador, id_equipo, num_camiseta
      const response = await postApi(URL, path, dataSend)
      // console.log(response)
      if (response.flag === 'si') {
        showMessageAlert('success', 'Jugador agregado exitosamente')
        emit('recargar', dataSend.id_equipo)
      } else {
        showMessageAlert('danger', response.mensaje)
      }
    }

    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_HISTORIAL', false)
    }
    function reset() {
      periodoSeleccionado.value = null
      listJugadores.value = []
      countDownChanged(0)
    }
    return {
      periodoSeleccionado,
      changePeriodo,
      listJugadores,
      avatarText,
      addPlayer,
      messageError,
      variante,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      showMessageAlert,
      hasError,
      onlyClose,
      reset,
      showLoading,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
